import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "components/CustomButtons/Button.js";
import Slide from "@material-ui/core/Slide";

import confirmationModalStyle from "assets/jss/material-dashboard-react/views/pageStyle";
import brandTheme from "brandTheme/Theme";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import { riskCategoryAndWeightageDeleteDataColumns } from "assets/properties/properties";
import { riskCategoryAuditLtv } from "assets/properties/properties";
import { riskCategoryMarketLtv } from "assets/properties/properties";
import { riskCategoryDpd } from "assets/properties/properties";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

class ConfirmationModal extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      confirmationModal: false,
      confirmationModalHeader: "",
      confirmationModalMsg: "",
      tableData: [],
    };
  }

  // Call parseIndicatorDataLtv when the component is mounted
  componentDidMount() {
    this.timeOutFunction = setTimeout(() => {
      this.setState({ cardAnimaton: "" });

      // Run this only if the props?.tableData is available
      if (this?.props?.tableData && this?.props?.tableData.length > 0) {
        this.parseIndicatorDataLtv();
      }
    }, 700);
  }

  // Clean up timeout when component unmounts
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  componentDidUpdate(prevProps) {
    // Only update state if the tableData prop has changed
    if (prevProps?.tableData !== this?.props?.tableData && this?.props?.tableData.length > 0) {
      this.parseIndicatorDataLtv();
    }
  }
  handlePositiveButton() {
    if (this?.props?.handlePositiveButton) {
      this?.props?.handlePositiveButton();
    }
  }

  handleNegativeButton() {
    this?.props?.handleNegativeButton();
  }

  // Function to parse data and update state
  parseIndicatorDataLtv = () => {
    let reportData = [];

    // Audited LTV
    this?.props?.tableData?.forEach((role, index) => {
      let row = {
        base: index === 0 ? riskCategoryAuditLtv?.auditLtvName : null,
        min: role?.minAuditedLtv || 0,
        max: role?.maxAuditedLtv || 0,
        score: role?.auditLtvScore || 0,
        viewCode: role?.id,
      };
      reportData.push(row);
    });

    // Market LTV
    this?.props?.tableData?.forEach((role, index) => {
      let row = {
        base: index === 0 ? riskCategoryMarketLtv?.marketLtvName : null,
        min: role?.minMarketLtv || 0,
        max: role?.maxMarketLtv || 0,
        score: role?.marketLtvScore || 0,
        viewCode: role?.id,
      };
      reportData.push(row);
    });

    // DPD
    this?.props?.tableData?.forEach((role, index) => {
      let row = {
        base: index === 0 ? riskCategoryDpd?.dpdName : null,
        min: role?.minDpd || 0,
        max: role?.maxDpd || 0,
        score: role?.dpdScore || 0,
        viewCode: role?.id,
      };
      reportData.push(row);
    });

    // Update the state with the reportData
    this.setState({ tableData: reportData });
  };
  static getDerivedStateFromProps(props, state) {
    if (props?.confirmationModal !== state?.confirmationModal) {
      let statusDetails = {};
      if (props?.confirmationModal) {
        statusDetails = {
          confirmationModal: props?.confirmationModal,
          confirmationModalHeader: props?.confirmationModalHeader,
          confirmationModalMsg: props?.confirmationModalMsg,
        };
      }
      return {
        confirmationModal: props?.confirmationModal,
        ...statusDetails,
      };
    }
    return null;
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal,
          }}
          open={this.state.confirmationModal}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleNegativeButton()}
          aria-labelledby="notice-modal-slide-title"
          aria-describedby="notice-modal-slide-description"
        >
          <DialogTitle
            id="notice-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
            <h4 className={classes.modalTitle}>
              {this.state.confirmationModalHeader}
            </h4>
          </DialogTitle>
          <DialogContent
            id="notice-modal-slide-description"
            className={classes.modalBody}
          >
            <p>{this.state.confirmationModalMsg}</p>
            {this?.props?.tableData && this?.props?.tableData.length > 0 &&
            <div>
              <ColumnGroupingTable
                columns={riskCategoryAndWeightageDeleteDataColumns}
                rows={this?.state?.tableData}
                noPagination
                rowPerPageData={30}
              />
            </div>
            }
          </DialogContent>
          <DialogActions
            className={classes.modalFooter + " " + classes.modalFooterCenter}
          >
            <Button
              onClick={() => this.handlePositiveButton()}
              color="info"
              round
              className={classes.nextButton}
            >
              {this?.props?.positiveButtonText
                ? this?.props?.positiveButtonText
                : "Confirm"}
            </Button>
            <Button
              onClick={() => this.handleNegativeButton()}
              color="info"
              className={classes.cancelButton}
              round
            >
              {this?.props?.negativeButtonText
                ? this?.props?.negativeButtonText
                : "Cancel"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

ConfirmationModal.propTypes = {
  classes: PropTypes.object.isRequired,
  confirmationModal: PropTypes.bool.isRequired,
  confirmationModalHeader: PropTypes.string,
  confirmationModalMsg: PropTypes.string.isRequired,
  handleNegativeButton: PropTypes.func.isRequired,
  handlePositiveButton: PropTypes.func.isRequired,
};

export default withStyles(confirmationModalStyle)(ConfirmationModal);
